import { render } from "./RoleLayout.vue?vue&type=template&id=9606d348&ts=true"
import script from "./RoleLayout.vue?vue&type=script&lang=ts"
export * from "./RoleLayout.vue?vue&type=script&lang=ts"

import "./RoleLayout.vue?vue&type=style&index=0&id=9606d348&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layout/RoleLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9606d348"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9606d348', __exports__)) {
    api.reload('9606d348', __exports__)
  }
  
  module.hot.accept("./RoleLayout.vue?vue&type=template&id=9606d348&ts=true", () => {
    api.rerender('9606d348', render)
  })

}


export default __exports__